export class HelpDocumentEdit
{
    public id = null;
    public version = 0;
    public name = '';
    public document: any;
    public enabled = true;
    public type = '';
    public url = '';
}
